export default __webpack_public_path__ + "static/media/644.05a42658.jpg";